module.exports = __webpack_public_path__ + "static/media/3.f1d284d1.jpg";